import CompLayout from "@/pcomponents/comp/layout/layout";
import WordInsideListArea from "@/pages/comp/plan/word/word_inside/common/list";

function WordInsidePage() {
  return (
    <CompLayout isConTitle={false}>
      <WordInsideListArea></WordInsideListArea>
    </CompLayout>
  );
};
export default WordInsidePage;